import * as React from "react";

export function html_space () {
    return <>&nbsp;</>
}